import { createIC } from '@/helpers/idle'


import { useEffect, useState } from 'react';
export function useMountIdle(
  callback: IdleRequestCallback,
  options?: IdleRequestOptions,
) {
  useEffect(() => {
    return createIC(callback, options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

let defaultIdleMounted = false

export function useIdleMounted() {
  const [idleMounted, setIdleMounted] = useState(defaultIdleMounted)

  useMountIdle(() => {
    setIdleMounted(true)
    defaultIdleMounted = true
  })

  return idleMounted
}
